import { createSlice, createAsyncThunk, type ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchUserProfile } from '../../services';
import { UserProfile } from '../../types/userProfile';

interface UserProfileState {
  loading: boolean;
  error: string | null;
  data: UserProfile | null;
}

const initialState: UserProfileState = {
  loading: false,
  error: null,
  data: null,
};

export const fetchCurrentUserProfile = createAsyncThunk<
  UserProfile,
  void
>('userProfile/fetchCurrentUserProfile', async () => {
  return await fetchUserProfile();
});

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    clearUserProfile: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<UserProfileState>) => {
    builder
      .addCase(fetchCurrentUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCurrentUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch user profile';
      });
  },
});

export const { clearUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
